import React, {useEffect, useState} from "react";
import "./RevealPage.css";
import defaultImg from 'asset/image/NFT_list-loading.png';
import nonNFTImg from 'asset/image/img_ genesis_none.svg';
import { useTranslation } from "react-i18next";
import {useSelector} from "react-redux";
import {HAVASWAP_URI,NftContractAddress} from "../../config/config";
const RevealPage = (props) => {
    const walletConnected = useSelector(state => state.walletSlice.connected);
    const [selectedNft, setSelectedNft] = useState();
    const {nftList, funcReveal } = props;
    const { t } = useTranslation();

    useEffect(()=>{
        //console.log("selectedNft",selectedNft);
    },[selectedNft])
    const handleBtnStatus = (isApproved, isRevealed, tokenId) =>{
        document.querySelector("#nft-exchange-btn_"+tokenId).classList.remove("active");
        document.querySelector("#nft-detail-btn_"+tokenId).style.display="none";
        if(isApproved){
            if(isRevealed){
                document.querySelector("#nft-exchange-btn_"+tokenId).style.display="none";
                document.querySelector("#nft-detail-btn_"+tokenId).style.display="flex";
                //document.querySelector("#nft-exchange-btn_"+tokenId).parentElement.style.display="none";
            }else{
                document.querySelector("#nft-exchange-btn_"+tokenId).classList.add("active");
            }
        }else{
            document.querySelector("#nft-exchange-btn_"+tokenId).classList.add("active");
        }
    }

    const funcMoveDetail = (tokenId) => {
        const id = Number(tokenId);
        //https://develop-havahswap.vercel.app/market/collection/cx37436f078297be0702c8482e820bbe71cd7fd4ff/아이디번호
        window.open(HAVASWAP_URI+NftContractAddress+"/"+id);
    }

    const funcClickNftItem = (li, nft) => {
        for (let childrenKey in li.parentElement.children) {
            if(li.id !==  li.parentElement.children.item(childrenKey).id ){
                li.parentElement.children.item(childrenKey).classList.remove("selected");
            }
        }
        if(li.classList.contains("selected")){
            setSelectedNft(null);
        }else{
            setSelectedNft(nft);
            handleBtnStatus(nft.isApproved, nft.isRevealed,nft.tokenId);
        }

        li.classList.toggle("selected");
    }

    const reveal = (tokenId) => {
        if(funcReveal(tokenId)){
            document.querySelector("#nft-exchange-btn_"+tokenId).classList.remove("active");
        }else{
            document.querySelector("#nft-exchange-btn_"+tokenId).classList.add("active");
        }
    }

    return (
        <div className={"reveal-page"}>
            <div className={
                `nft-list-wrap${nftList.length !== 0 && walletConnected ? "": " no-nft"}`
            }>
                { walletConnected ?
                    nftList.length !== 0 ?
                     <>
                        <p className={"nft-reveal-text"}>{t("REVEAL_GUIDE")}</p>

                        <ul className={"nft-list"}>
                            {nftList.map((nft,index)=>{
                                let nftDesc;

                                if(nft.isRevealed){// reveal 완료 nft
                                    nftDesc = (
                                        <>
                                            <h2 className={"nft-desc-kind"}>{nft.kind}</h2>
                                            <div className={"nft-desc-rarity "+nft.rarity}>{nft.rarity}</div>
                                        </>
                                    );
                                }else{// reveal 미완료 nft
                                    nftDesc = (
                                        <>
                                            <h2 className={"nft-desc-price"}>Vehicle Box</h2>
                                            <div className={"nft-desc-unit"}>Genesis</div>
                                        </>
                                    );
                                }

                                return (
                                    <li key={index}
                                        id={"nft-item_"+index}
                                        className={"nft-item"}
                                        onClick={(e)=> {funcClickNftItem(e.currentTarget,nft)}}
                                    >
                                        <img className={`nft-item-img`}
                                             src={
                                                 nft.isRevealed ? nft.image : nft.image
                                             } width={224} height={224}
                                             onError={(e) => {e.currentTarget.src = defaultImg}}
                                             onLoad={(e)=>{
                                                 e.currentTarget.classList.add("loaded" + nft.isRevealed ? nft.rarity : "");
                                             }}
                                        />
                                        <div className={"nft-item-desc-wrap"}>
                                            <p className={"nft-desc-id"}> # {nft.id}</p>
                                            <div className={"nft-desc"}>
                                                {nftDesc}
                                            </div>
                                        </div>
                                        <div  className={"nft-exchange-btn-wrap"}>
                                            <div id={"nft-exchange-btn_"+nft.tokenId} className={"nft-exchange-btn reveal-btn"}
                                                 onClick={(e)=>{ if(e.currentTarget.classList.contains("active")){reveal(nft.tokenId)}}}
                                            >
                                                <svg className={"nft-exchange-btn-svg"} xmlns="http://www.w3.org/2000/svg">
                                                    <defs>
                                                        <linearGradient id="Gradient" x1="0" x2="80" y1="0" y2="0" gradientUnits="userSpaceOnUse">
                                                            <stop stopColor="#A02FD0" offset="0"/>
                                                            <stop stopColor="#601DE6" offset="1"/>
                                                        </linearGradient>
                                                    </defs>
                                                    <rect x="1" y="1" height="100%" width="100%" style={{width:"calc(100% - 2px)",height:"calc(100% - 2px)"}} rx="5" ry="5" strokeWidth="2" fill="transparent" stroke="url(#Gradient)"/>
                                                </svg>
                                                EXCHANGE
                                            </div>

                                            <div id={"nft-detail-btn_"+nft.tokenId} className={"nft-exchange-btn detail-btn active"}
                                                 onClick={(e)=>{ if(e.currentTarget.classList.contains("active")){funcMoveDetail(nft.tokenId)}}}
                                            >
                                                <svg className={"nft-exchange-btn-svg"} xmlns="http://www.w3.org/2000/svg">
                                                    <defs>
                                                        <linearGradient id="Gradient" x1="0" x2="80" y1="0" y2="0" gradientUnits="userSpaceOnUse">
                                                            <stop stopColor="#A02FD0" offset="0"/>
                                                            <stop stopColor="#601DE6" offset="1"/>
                                                        </linearGradient>
                                                    </defs>
                                                    <rect x="1" y="1" height="100%" width="100%" style={{width:"calc(100% - 2px)",height:"calc(100% - 2px)"}} rx="5" ry="5" strokeWidth="2" fill="transparent" stroke="url(#Gradient)"/>
                                                </svg>
                                                DETAIL
                                            </div>
                                        </div>
                                    </li>
                                )
                            })}
                        </ul>
                    </>
                    :
                        <div className={"no-nft-list"}>
                            <img className={"no-nft-img"} src={nonNFTImg} alt={"no-nft"}/>
                            <p className={"no-nft-text"}>{t("NONNFT_POPUP")}</p>
                        </div>
                    :
                    <div className={"no-nft-list"}>
                        <img className={"no-nft-img"} src={nonNFTImg} alt={"no-nft"}/>
                        <p className={"no-nft-text"}>{t("REVEALCONNECT_GUIDE")}</p>
                    </div>
                }
            </div>

            {/*<div className={"nft-exchange-wrap"}>*/}
            {/*    <div className={"nft-exchange-btn approve-btn"}*/}
            {/*         onClick={(e)=>{ if(e.currentTarget.classList.contains("active")){approve()}}}*/}
            {/*    >*/}
            {/*        <svg className={"nft-exchange-btn-svg"} xmlns="http://www.w3.org/2000/svg">*/}
            {/*            <defs>*/}
            {/*                <linearGradient id="Gradient" x1="0" x2="80" y1="0" y2="0" gradientUnits="userSpaceOnUse">*/}
            {/*                    <stop stopColor="#A02FD0" offset="0"/>*/}
            {/*                    <stop stopColor="#601DE6" offset="1"/>*/}
            {/*                </linearGradient>*/}
            {/*            </defs>*/}
            {/*            <rect x="1" y="1" height="100%" width="100%" style={{width:"calc(100% - 2px)",height:"calc(100% - 2px)"}} rx="5" ry="5" strokeWidth="2" fill="transparent" stroke="url(#Gradient)"/>*/}
            {/*        </svg>*/}
            {/*        APPROVE*/}
            {/*    </div>*/}
            {/*    <div className={"nft-exchange-btn reveal-btn"}*/}
            {/*        onClick={(e)=>{ if(e.currentTarget.classList.contains("active")){reveal()}}}*/}
            {/*    >*/}
            {/*        <svg className={"nft-exchange-btn-svg"} xmlns="http://www.w3.org/2000/svg">*/}
            {/*            <defs>*/}
            {/*                <linearGradient id="Gradient" x1="0" x2="80" y1="0" y2="0" gradientUnits="userSpaceOnUse">*/}
            {/*                    <stop stopColor="#A02FD0" offset="0"/>*/}
            {/*                    <stop stopColor="#601DE6" offset="1"/>*/}
            {/*                </linearGradient>*/}
            {/*            </defs>*/}
            {/*            <rect x="1" y="1" height="100%" width="100%" style={{width:"calc(100% - 2px)",height:"calc(100% - 2px)"}} rx="5" ry="5" strokeWidth="2" fill="transparent" stroke="url(#Gradient)"/>*/}
            {/*        </svg>*/}
            {/*        EXCHANGE*/}
            {/*    </div>*/}
            {/*</div>*/}
        </div>
    );
}

export default RevealPage;